import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchProductListOfStore,
  getAllProducts,
  getAllSearchProducts,
  searchProduct,
  searchProductListOfStore,
} from "../../../redux/Thunk/Product/ProductThunks";
import {
  setAdminProduct,
  setSearchProducts,
} from "../../../redux/Reducer/Product/ProductSlice";
import { setActiveForm } from "../../../redux/Reducer/Admin/PartnerSlice";
import CloseBorder from "../../common/icons/CloseBorder";
import ArrowDown from "../../common/icons/ArrowDown";
import toast from "react-hot-toast";
import ProductListType from "../../common/ProductListType";
import { debounce } from "lodash";
import { useOutsideClick } from "../../common/useOutsideClick";
import { extentions } from "../../../utils/constants";

const SearchSelectProduct = ({
  selectedProduct,
  setSelectedProduct,
  role,
  activeTabName,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dispatch = useDispatch();
  const SID = useSelector((state) => state.store.storeDetail?.store?.SID);
  const storeId = useSelector((state) => state?.store?.storeById?.SID);

  const activeForm = useSelector((state) => state.formSwitcher?.activeForm);
  const {
    productList,
    searchProduct: searchedProduct,
  } = useSelector((state) => state?.product);

  const handleClickOutside = (event) => {
    // Ensure the dropdownRef and event are valid before accessing properties
    if (dropdownRef?.current && !dropdownRef?.current.contains(event?.target)) {
      setIsOpen(false);
    }
  };
  const dropdownRef = useOutsideClick(handleClickOutside);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (activeForm === "product") {
      dispatch(setSearchProducts([]));
    }
  }, [dispatch, activeForm]);

  useEffect(() => {
    if (productList) {
      let products =
        productList?.length > 0
          ? productList
          : productList?.data?.length > 0
          ? productList?.data
          : "";
      setProducts(products);
    }
  }, [searchedProduct, productList]);

  useEffect(() => {
    if (searchedProduct?.length === 0) {
      setSelectedProduct("");
    } else {
      setSelectedProduct(searchedProduct[0]);
    }
  }, [searchedProduct, setSelectedProduct]);

  const handleToggleDropdown = () => {
    if (isOpen) {
      setIsOpen(false);
    } else {
      setIsOpen(true);
      setTimeout(() => {
        const input = document.getElementById("searchProduct");
        input?.focus();
      }, 0);
    }
  };

  const handleSelectProduct = async (product) => {
    dispatch(setActiveForm(""));
    setSelectedProduct(product);
    let name = product?.productName || product?.product?.productName;
    let IID = product?.IID || product?.product?.IID;
    let SID = storeId;
    let response;
    if (activeTabName === "Stock") {
      if (role === "admin") {
        response = await dispatch(
          getAllProducts({ current_page: 1, PID: IID, SID })
        ).unwrap();
      } else if (role === "store") {
        response = await dispatch(
          fetchProductListOfStore({ page: 1, limit: 10, search: name })
        ).unwrap();
        // response = await dispatch(searchProduct({ name, IID })).unwrap();
      }
    } else {
      response = await dispatch(searchProduct({ name, IID })).unwrap();
    }
    if (response.status === 200) {
      setSearchTerm("");
    } else {
      toast.error(response?.message);
    }
    setIsOpen(false);
  };

  const handleClearSearch = (e) => {
    e.stopPropagation();
    setSelectedProduct("");
    setSearchTerm("");
    dispatch(setSearchProducts([]));
    setIsOpen(false);
    if (role === "admin") {
      dispatch(getAllProducts({ current_page: "", SID: storeId }));
    } else {
      if (!searchTerm.length) {
        dispatch(fetchProductListOfStore({ page: 1, limit: 10, search: "" }));
      }
      dispatch(setAdminProduct([]));
    }
  };
  const storeStockValue = searchedProduct[0]?.storeProducts?.find(
    (obj) => obj.SID === SID
  );
  const debouncedSearch = React.useMemo(
    () =>
      debounce((search, SID) => {
        if (role === "store") {
        if (search?.length > 0) {
          dispatch(
            searchProductListOfStore({ page: 1, limit: 10, search: search })
          );
        } else {
          dispatch(fetchProductListOfStore({ page: 1, limit: 10, search: "" }));
        }
      } else if (role === "admin") {
        if (search?.length > 0) {
          dispatch(
            getAllSearchProducts({
              search,
              SID,
            })
          );
        } else {
          dispatch(
            getAllSearchProducts({
              search: "",
              SID,
            })
          );
        }
      }
    }, 300),
    [dispatch, role]
  );

  const handleChange = (e) => {
    e.preventDefault();
    const value = e.target.value.trimStart();
    let SID = storeId;
    setSearchTerm(value);

    debouncedSearch(value, SID);
  };
  const stock =
    storeStockValue?.storeStock !== undefined &&
    storeStockValue?.storeStock !== null
      ? storeStockValue?.storeStock
      : selectedProduct?.storeStock === 0
      ? 0
      : selectedProduct?.storeStock || selectedProduct?.productStock;

  return (
    <div className="relative w-full min-w-0" ref={dropdownRef} onClick={(e) => e.stopPropagation()}>
      <div
        onClick={handleToggleDropdown}
        className={`flex min-h-[60px] h-full text-[16px] items-center justify-between gap-3 text-black border border-primary-100 bg-primary-50 py-[8px] px-[12px] w-full min-w-0 outline-none cursor-pointer transition-all duration-200 overflow-hidden ${isOpen ? "rounded-t-lg border-primary-200 bg-white" : "rounded-lg hover:border-primary-200 shadow-sm"}`}
      >
        {(selectedProduct?.product?.productName || selectedProduct?.productName) ? (
          <div className="flex items-start flex-1 min-w-0 py-1 overflow-hidden">
            <div className="text-left w-full min-w-0 flex flex-col justify-center">
              <h5 className="text-[14px] font-semibold text-primary-700 leading-tight truncate">
                {selectedProduct?.product?.productName || selectedProduct?.productName || ""}
              </h5>
              <div className="min-w-0 flex flex-col gap-0.5 mt-0.5">
                <p className="text-[10px] text-primary-500 truncate uppercase tracking-tight">
                  {selectedProduct?.product?.type || selectedProduct?.type} .{" "}
                  {`${selectedProduct?.product?.uom || selectedProduct?.uom} ${
                    extentions[selectedProduct?.product?.type || selectedProduct?.type]?.uomExt ||
                    extentions[selectedProduct?.product?.type || selectedProduct?.type]?.extention || ""
                  }`}
                </p>
                <div className="flex items-center gap-1 min-w-0">
                  <p className="text-[10px] text-primary-400 truncate flex-1 italic">
                    { (selectedProduct?.product?.drugs || selectedProduct?.drugs)?.length > 0 ? (
                        (selectedProduct?.product?.drugs || selectedProduct?.drugs)
                          ?.slice(0, 3)
                          ?.map((drug) => drug?.name ? drug?.name : drug)
                          ?.join(", ") +
                        ((selectedProduct?.product?.drugs || selectedProduct?.drugs)?.length > 3 ? "..." : "")
                      ) : "No drugs"
                    }
                  </p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="flex justify-center items-center flex-1 w-full h-full">
            <input
              id="searchProduct"
              type="text"
              placeholder="Search or Select Product"
              value={searchTerm}
              onChange={(e) => {
                handleChange(e);
                if (!isOpen) setIsOpen(true);
              }}
              onFocus={() => {
                setIsFocused(true);
                if (!isOpen) setIsOpen(true);
              }}
              onBlur={() => setIsFocused(false)}
              onClick={(e) => {
                if (!isOpen) setIsOpen(true);
                e.stopPropagation();
              }}
              className={`w-full h-full text-primary-700 text-[15px] font-semibold bg-transparent outline-none placeholder:text-primary-700 placeholder:opacity-50 transition-all duration-300 ${(searchTerm || isFocused) ? "text-left pl-2" : "text-center"}`}
            />
          </div>
        )}

        <div className="flex items-center gap-2 h-full flex-none">
          <div className="flex flex-col items-end min-w-0 flex-none border-l border-primary-100 pl-2">
            <div className="flex gap-1.5 items-center">
              <span className={`text-[13px] font-semibold ${
                stock > 6 ? "text-success-600" : Number(stock) === 0 ? "text-primary-600" : "text-yellow-700"
              }`}>
                {stock}
              </span>
              <span className="text-[10px] font-semibold text-blue-500 uppercase flex-none">
                {selectedProduct?.product?.lookupMargin?.type || selectedProduct?.lookupMargin?.type || ""}
              </span>
            </div>
          </div>
          <div className="flex items-center gap-0.5 flex-none border-l border-primary-100 pl-1">
            {(selectedProduct?.productName || selectedProduct?.product?.productName) && (
              <button
                onClick={handleClearSearch}
                className="p-1 hover:bg-primary-100 rounded-full transition-colors flex-none scale-90"
                title="Clear selection"
              >
                <CloseBorder />
              </button>
            )}
            <button className={`p-1 hover:bg-primary-100 rounded-full transition-transform duration-200 flex-none scale-90 ${isOpen ? "rotate-180" : ""}`}>
              <ArrowDown />
            </button>
          </div>
        </div>
      </div>
        {isOpen && (
          <div className="absolute w-full mt-[1px] bg-white border border-primary-200 rounded-b-lg shadow-xl z-50 overflow-hidden">
            {(selectedProduct?.productName || selectedProduct?.product?.productName) && (
              <div className="p-2 bg-primary-50/50 border-b border-primary-100">
                <input
                  id="searchProduct"
                  type="text"
                  placeholder="Search Product..."
                  value={searchTerm}
                  onChange={(e) => handleChange(e)}
                  className="w-full p-2 border border-primary-200 focus:outline-none rounded-md text-sm"
                />
              </div>
            )}
          {/* {loading ? <Loader loading={loading} /> : null} */}
          <ul className="max-h-[calc(90vh_-_150px)] overflow-y-auto">
            {products?.length > 0 ? (
              products?.map((product) => (
                <li
                  key={product?.IID || product?.product?.IID}
                  onClick={() => handleSelectProduct(product)}
                  className="p-2.5 justify-between cursor-pointer hover:bg-neutral-50 transition-colors flex gap-2 border-b border-gray-50 last:border-0"
                >
                  <ProductListType
                    product={product?.product || product}
                    stock={product?.storeStock === 0 ? 0 : product?.storeStock || product?.productStock}
                    findStoreStock={() => product?.storeStock === 0 ? 0 : product?.storeStock || product?.productStock}
                  />
                </li>
              ))
            ) : (
              <li className="p-4 text-gray-500 text-sm italic text-center">No products found</li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SearchSelectProduct;
